import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { PopularDestinations } from '../models/popular-destinations.model';
import { PopularDestinationsRepository } from '../repositories/popular-destinations.repository';

export class GetPopularDestinationsUseCase
    implements UseCase<void, PopularDestinations>
{
    constructor(private readonly repository: PopularDestinationsRepository) {}

    execute(): Observable<PopularDestinations> {
        return this.repository.getPopularDestinations();
    }
}
